import { render, staticRenderFns } from "./modalFiltro.vue?vue&type=template&id=a2636d1a&scoped=true"
import script from "./modalFiltro.vue?vue&type=script&lang=js"
export * from "./modalFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2636d1a",
  null
  
)

export default component.exports